import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rbtick",
  "use": "icon-rbtick-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-rbtick\"><defs><style type=\"text/css\"></style></defs><path d=\"M256 1024h768V256l-768 768z m493.6-108.8L704 960l-45.6-45.6L576 832l45.6-45.6L704 869.6l210.4-210.4 45.6 45.6-210.4 210.4z\" p-id=\"3849\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol